var ClientRole;
(function (ClientRole) {
    ClientRole[ClientRole["Universal"] = 1] = "Universal";
    ClientRole[ClientRole["CreatorAndApprover"] = 2] = "CreatorAndApprover";
    ClientRole[ClientRole["Verifier"] = 3] = "Verifier";
    ClientRole[ClientRole["Watcher"] = 4] = "Watcher";
})(ClientRole || (ClientRole = {}));
export default ClientRole;
